export enum FxRateLockerModes {
  leftLeg = 1,
  rightLeg = 2,
  fxRate = 3,
}
